export default __webpack_public_path__ + "static/partnerIcon5-47082048de2ff852e0b9d8e304346144.svg";